import i18n from 'i18next';

/**
 * Best-effort message extractor for unknown error values.
 */
export const safelyGetErrorMessage = (error: unknown, fallback = 'There has been an error.') => {
  try {
    if (typeof error === 'string') {
      return error;
    }
    if (typeof error === 'object' && error !== null && 'message' in error) {
      const message = (error as { message?: unknown }).message;
      return typeof message === 'string' ? message : fallback;
    }
    return fallback;
  } catch {
    return fallback;
  }
};

const MISSING_PERMISSION = 'Missing required permission: ';

const PERMISSION_MESSAGE_KEYS: Record<string, string> = {
  'conversations.assign.agent': 'permissions.cannot_assign_conversation',
  'conversations.assign.department': 'permissions.cannot_transfer_conversation',
};

export const friendlyErrorMessage = (error: unknown): string => {
  const message = safelyGetErrorMessage(error);
  if (!message.startsWith(MISSING_PERMISSION)) {
    return message;
  }
  const permission = message.slice(MISSING_PERMISSION.length).trim();

  return i18n.t(PERMISSION_MESSAGE_KEYS[permission] ?? 'permissions.missing_generic');
};

/**
 * Best-effort error code extractor.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const safelyGetErrorCode = (error: any, fallback = 'unknown') => {
  if (typeof error === 'string') {
    return error;
  }
  return error?.extra?.code || error?.code || fallback;
};
